import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/posys-logo-small.png'
import _imports_1 from '@/assets/img/login-img.png'


const _withScopeId = n => (_pushScopeId("data-v-61911658"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Posys Image",
    width: "30%"
  })
], -1))
const _hoisted_2 = { class: "form-container" }
const _hoisted_3 = { class: "steps-content" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "label-form2" }
const _hoisted_6 = { class: "label-form2" }
const _hoisted_7 = { class: "label-form2" }
const _hoisted_8 = { class: "label-form2" }
const _hoisted_9 = { class: "label-form2" }
const _hoisted_10 = { class: "label-form2" }
const _hoisted_11 = { class: "label-form2" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "label-form2" }
const _hoisted_14 = { class: "label-form2" }
const _hoisted_15 = { class: "label-form2" }
const _hoisted_16 = { class: "label-form2" }
const _hoisted_17 = { class: "label-form2" }
const _hoisted_18 = { class: "label-form2" }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { class: "label-form2" }
const _hoisted_21 = { class: "label-form2" }
const _hoisted_22 = { class: "ant-upload-drag-icon" }
const _hoisted_23 = { class: "ant-upload-text" }
const _hoisted_24 = { class: "ant-upload-hint" }
const _hoisted_25 = { class: "steps-action" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Posys Image",
  width: "80%"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_config_provider = _resolveComponent("a-config-provider")!
  const _component_LbrxLoaderSpinner = _resolveComponent("LbrxLoaderSpinner")!
  const _component_a_steps = _resolveComponent("a-steps")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_InboxOutlined = _resolveComponent("InboxOutlined")!
  const _component_a_upload_dragger = _resolveComponent("a-upload-dragger")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_config_provider, {
      theme: {
      token: {
        colorPrimary: _ctx.themeTemplate.primaryColor,
        fontFamily: 'Exo 2',
      },
      }
    }, null, 8, ["theme"]),
    _createElementVNode("div", null, [
      _createVNode(_component_LbrxLoaderSpinner, {
        "is-loaded": !_ctx.loading
      }, null, 8, ["is-loaded"])
    ]),
    _createVNode(_component_a_row, { class: "login-container" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          xs: { span: 24},
          sm: { span: 24},
          md: {span: 11},
          lg: { span: 11 },
          xl: { span: 11 },
          xxl: { span: 11 },
          class: "side-container"
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_steps, {
                current: _ctx.current,
                items: _ctx.items
              }, null, 8, ["current", "items"]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_a_form, {
                  ref: "registerFormRef",
                  model: _ctx.registerForm,
                  rules: _ctx.rulesForRegister,
                  layout: "vertical"
                }, {
                  default: _withCtx(() => [
                    (_ctx.steps[_ctx.current].content==='first-content')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createVNode(_component_a_row, { gutter: 16 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, { name: "name" }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.t('Pos.Name')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input, {
                                        placeholder: _ctx.t('Pos.Name'),
                                        value: _ctx.registerForm.name,
                                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.registerForm.name) = $event))
                                      }, null, 8, ["placeholder", "value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_row, { gutter: 16 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, { name: "first_name" }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t('Pos.FisrtName')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input, {
                                        placeholder: _ctx.t('Pos.FisrtName'),
                                        value: _ctx.registerForm.first_name,
                                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.registerForm.first_name) = $event))
                                      }, null, 8, ["placeholder", "value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, { name: "last_name" }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.t('Pos.LastName')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input, {
                                        placeholder: _ctx.t('Pos.LastName'),
                                        value: _ctx.registerForm.last_name,
                                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.registerForm.last_name) = $event))
                                      }, null, 8, ["placeholder", "value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_row, { gutter: 16 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, {
                                    name: "email",
                                    "has-feedback": "",
                                    "validate-status": _ctx.validatingStatus,
                                    help: _ctx.validatingHelp
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.t('Pos.Email')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input, {
                                        placeholder: _ctx.t('Pos.Email'),
                                        value: _ctx.registerForm.email,
                                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.registerForm.email) = $event)),
                                        onBlur: _ctx.validateEmail
                                      }, null, 8, ["placeholder", "value", "onBlur"])
                                    ]),
                                    _: 1
                                  }, 8, ["validate-status", "help"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, { name: "username" }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.t('Pos.Username')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input, {
                                        placeholder: _ctx.t('Pos.Username'),
                                        value: _ctx.registerForm.username,
                                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.registerForm.username) = $event))
                                      }, null, 8, ["placeholder", "value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_row, { gutter: 16 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, { name: "password" }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.t('Pos.Password')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input_password, {
                                        value: _ctx.registerForm.password,
                                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.registerForm.password) = $event)),
                                        placeholder: _ctx.t('Pos.Password'),
                                        type: "password",
                                        autocomplete: "off"
                                      }, null, 8, ["value", "placeholder"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, { name: "checkPass" }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.t('Pos.Confirmpassword')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input_password, {
                                        value: _ctx.registerForm.checkPass,
                                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.registerForm.checkPass) = $event)),
                                        placeholder: _ctx.t('Pos.Confirmpassword'),
                                        type: "password",
                                        autocomplete: "off"
                                      }, null, 8, ["value", "placeholder"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.steps[_ctx.current].content==='second-content')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createVNode(_component_a_row, { gutter: 16 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, { name: "phone" }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.t('Pos.Phone')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input, {
                                        placeholder: _ctx.t('Pos.Phone'),
                                        value: _ctx.registerForm.phone,
                                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.registerForm.phone) = $event))
                                      }, null, 8, ["placeholder", "value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, { name: "phone_number" }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.t('Pos.phone_number')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input, {
                                        placeholder: _ctx.t('Pos.phone_number'),
                                        value: _ctx.registerForm.phone_number,
                                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.registerForm.phone_number) = $event))
                                      }, null, 8, ["placeholder", "value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_row, { gutter: 16 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, { name: "Address" }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.t('Pos.Address')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input, {
                                        placeholder: _ctx.t('Pos.Address'),
                                        value: _ctx.registerForm.address,
                                        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.registerForm.address) = $event))
                                      }, null, 8, ["placeholder", "value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_row, { gutter: 16 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, { name: "registration_number" }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.t('Pos.registration_number')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input, {
                                        placeholder: _ctx.t('Pos.registration_number'),
                                        value: _ctx.registerForm.registration_number,
                                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.registerForm.registration_number) = $event))
                                      }, null, 8, ["placeholder", "value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, { name: "vat_number" }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.t('Pos.vat_number')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input, {
                                        placeholder: _ctx.t('Pos.vat_number'),
                                        value: _ctx.registerForm.vat_number,
                                        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.registerForm.vat_number) = $event))
                                      }, null, 8, ["placeholder", "value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_row, { gutter: 16 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, { name: "category" }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.t('Pos.Category')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_select, {
                                        value: _ctx.registerForm.category,
                                        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.registerForm.category) = $event)),
                                        placeholder: _ctx.t('Pos.CurrencyChoose'),
                                        "show-search": "",
                                        "option-filter-prop": 'label'
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.data, (category) => {
                                            return (_openBlock(), _createBlock(_component_a_select_option, {
                                              key: category.id,
                                              value: category.id,
                                              label: category.name
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(category.name), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["value", "label"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["value", "placeholder"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.steps[_ctx.current].content==='third-content')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createVNode(_component_a_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, { name: "Description" }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.t('Pos.Description')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_textarea, {
                                        value: _ctx.registerForm.description,
                                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.registerForm.description) = $event)),
                                        rows: 4,
                                        placeholder: _ctx.t('Pos.Description')
                                      }, null, 8, ["value", "placeholder"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_row, { gutter: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, null, {
                                    label: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.t('Pos.Logo')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_upload_dragger, {
                                        fileList: _ctx.fileList,
                                        "onUpdate:fileList": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.fileList) = $event)),
                                        name: "file",
                                        multiple: false,
                                        "max-count": 1,
                                        onChange: _ctx.handleChangeFile,
                                        onDrop: _ctx.handleDrop,
                                        "before-upload": _ctx.beforeUpload
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("p", _hoisted_22, [
                                            _createVNode(_component_InboxOutlined)
                                          ]),
                                          _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.t('Pos.dropTitle1')), 1),
                                          _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.t('Pos.dropTitle2')), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["fileList", "onChange", "onDrop", "before-upload"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]),
              _createElementVNode("div", _hoisted_25, [
                (_ctx.current < _ctx.steps.length - 1)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      type: "primary",
                      onClick: _ctx.next
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('Pos.Next')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.current == _ctx.steps.length - 1)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 1,
                      type: "primary",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.submitRegister()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('Pos.register')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.current > 0)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 2,
                      style: {"margin-left":"8px"},
                      onClick: _ctx.prev
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('Pos.Previous')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.t('Pos.LoginInText')) + " ", 1),
                _createElementVNode("span", {
                  class: "register-title",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.navigatePage('/login')))
                }, _toDisplayString(_ctx.t('Pos.SignIn')), 1)
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          xs: { span: 24},
          sm: { span: 24},
          md: {span: 13},
          lg: { span: 13 },
          xl: { span: 13 },
          xxl: { span: 13 },
          class: "login-img"
        }, {
          default: _withCtx(() => [
            _hoisted_26
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}